import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap',
    'font-display font-semibold tracking-tight',
    'transition-all duration-200',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
    'disabled:pointer-events-none disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        primary: [
          'bg-primary text-white',
          'shadow-lg shadow-primary/25',
          'hover:bg-primary-soft hover:shadow-primary/40 hover:-translate-y-px',
          'active:translate-y-0',
        ],
        secondary: [
          'gradient-accent text-white',
          'shadow-lg shadow-secondary/25',
          'hover:opacity-95 hover:shadow-secondary/40 hover:-translate-y-px',
          'active:translate-y-0',
        ],
        outline: [
          'border border-border-strong text-fg bg-transparent',
          'hover:bg-surface hover:border-fg-subtle',
        ],
        ghost: ['text-fg hover:bg-surface'],
        danger: [
          'border border-danger/40 text-danger bg-transparent',
          'hover:bg-danger/10 hover:border-danger',
        ],
      },
      size: {
        sm: 'h-9 px-3 text-sm rounded-md',
        md: 'h-11 px-5 text-sm rounded-lg',
        lg: 'h-12 px-7 text-base rounded-xl',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)

export type ButtonVariantProps = VariantProps<typeof buttonVariants>
